module.exports = __webpack_public_path__ + "media/ACAM-CK-AUDIO-1.370ce093.mp3";